import './historicMovedApplication.scss';
import * as angular from 'angular';
import { ItemsInHeader, ListApplicationsAccount } from 'modules/shared/ApplicationTypings';
import { TenantRoles } from 'modules/application/tenant/TenantService';
import foldToASCII from 'data/foldToASCII';
import { ORGANIZATION_CHATBOTS_SEARCH } from 'modules/application/tenant/TenantSegmentEvents';
const OnSeachEvent = 'OnSeachEvent';
const MASTER = 'master';
const BUILDER = 'builder';
export class HistoricMovedApplicationController {
    static $inject = ['$state', '$rootScope', '$translate', '$window', '$location', 'ContextProcessorService', 'ApplicationService2', 'TenantService', 'AccountService2', 'LoadingService', 'SegmentService', 'BLIP_DOMAIN'];
    constructor($state, $rootScope, $translate, $window, $location, ContextProcessorService, ApplicationService2, TenantService, AccountService2, LoadingService, SegmentService, BLIP_DOMAIN) {
        'ngInject';
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$window = $window;
        this.$location = $location;
        this.ContextProcessorService = ContextProcessorService;
        this.ApplicationService2 = ApplicationService2;
        this.TenantService = TenantService;
        this.AccountService2 = AccountService2;
        this.LoadingService = LoadingService;
        this.SegmentService = SegmentService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.isMoving = true;
        this.viewHistoricDetail = {};
        this.noSearchResults = false;
        this.$rootScope.$on(OnSeachEvent, (_, text) => this.onSearchBots(text));
        this.onInit();
    }
    async onInit() {
        this.LoadingService.startLoading(false);
        try {
            await this.ContextProcessorService.waitForInitialization();
            if (this.$window.location.pathname == '/application/historic') {
                this.tenantId = this.TenantService.getTenantPrefixFromUrl();
                const isTenantAdmin = await this.TenantService.currentUserHasRequiredTenantRole(this.tenantId, [TenantRoles.Admin]);
                this.historic = await this.getHistoric(this.tenantId, isTenantAdmin);
                this.isMoving = false;
            }
            const promises = [];
            const putLisApplication = await this.flowCheckedRouter();
            promises.push(putLisApplication);
            const indexsOfMigraton = await this.getHistoricIndices(this.historic);
            if (indexsOfMigraton !== undefined) {
                this.viewHistoricDetail = await this.createIndexOfList(indexsOfMigraton);
                promises.push(this.viewHistoricDetail);
            }
            const promise = await this.getUser();
            promises.push(promise);
            await Promise.all(promises);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    view(index) {
        return this.viewHistoricDetail[index];
    }
    async getHistoric(tenantId, isAdm) {
        if (isAdm) {
            return this.ApplicationService2.getHistoricApplications(tenantId);
        }
        else {
            const user = await this.AccountService2.me();
            const userIdentity = encodeURIComponent(`${user.email}`);
            return this.ApplicationService2.getHistoricApplications(tenantId, undefined, userIdentity);
        }
    }
    async getUser() {
        return this.historic?.forEach(async (e) => {
            e.User = await this.AccountService2.get(encodeURIComponent(e.UserIdentity));
        });
    }
    async createIndexOfList(indexsOfMigraton) {
        return this.historic?.map((_, index) => indexsOfMigraton.indexOf(index) > -1);
    }
    async getHistoricIndices(historic) {
        return historic?.reduce((indices, current, currentIndex) => {
            if (current.Applications) {
                indices.push(currentIndex);
            }
            return indices;
        }, []);
    }
    async createListHistoricInExhibition(index) {
        this.viewHistoricDetail[index] = !this.viewHistoricDetail[index];
    }
    async flowCheckedRouter() {
        this.historic?.forEach(i => {
            i.lengthTotal = i.Applications.items.length;
            i.ListApplicationsAccount = new ListApplicationsAccount();
            i.ListApplicationsAccount.itemsInHeader = [];
            i.Applications.items.forEach(async (item) => {
                if (item.template !== MASTER) {
                    return;
                }
                const children = await this.getChildren(item.shortName, i.DestinationTenantId);
                if (children !== undefined) {
                    item.blocked = false;
                    const newList = new ItemsInHeader();
                    newList.id = item.shortName;
                    newList.name = item.name;
                    newList.applications = [];
                    newList.applications.push(item);
                    this.removeToListContact(i.Applications.items, item);
                    children.forEach(element => {
                        this.changeStateBots(element, true);
                        newList.applications.push(element);
                        this.removeToListContact(i.Applications.items, element);
                    });
                    i.ListApplicationsAccount.itemsInHeader.push(newList);
                    i.ListApplicationsAccount.indexList = newList.applications.length;
                }
            });
        });
    }
    async getChildren(shortName, tenantId) {
        return await this.ApplicationService2.getApplicationsWithChildren(shortName, tenantId);
    }
    removeToListContact(listApplications, contact) {
        const indexToRemove = listApplications.findIndex((application) => contact.shortName === application.shortName);
        if (indexToRemove === -1) {
            if (contact.showApplication === undefined && contact.template === BUILDER) {
                contact.showApplication = false;
            }
        }
        else {
            if (contact.showApplication === undefined) {
                contact.showApplication = true;
            }
            listApplications.splice(indexToRemove, 1);
        }
    }
    changeStateBots(contact, status) {
        contact.checked = status;
        contact.blocked = status;
        contact.disabled = status;
    }
    hideListHistoricInExhibition(index) {
        this.viewHistoricDetail[index] = !this.viewHistoricDetail[index];
    }
    onSearchBots(text) {
        const searchText = foldToASCII(text).toLowerCase();
        this.searchText = text;
        this.noSearchResults = false;
        this.applicationsBuffer = angular.copy(this.applicationsInExhibition);
        if (searchText.length > 2) {
            const searchResults = this.applicationsBuffer.filter((x) => foldToASCII(x.name)
                .toLowerCase()
                .includes(searchText));
            const tenant = this.ContextProcessorService.tenant;
            if (tenant && tenant.id) {
                this.SegmentService.createTrack(ORGANIZATION_CHATBOTS_SEARCH, {
                    status: 'success',
                    organizationName: tenant.name,
                    organizationUrl: this.TenantService.getTenantUrl(tenant.id),
                    text: searchText,
                    qtdItens: searchResults.length,
                });
            }
            if (searchResults.length > 0) {
                this.applicationsInExhibition = searchResults;
                this.searchResults = undefined;
            }
            else {
                this.applicationsInExhibition = [];
                this.noSearchResults = true;
            }
        }
        else {
            this.searchText = undefined;
        }
        this.applicationsBuffer = undefined;
    }
}
HistoricMovedApplicationController.$inject = ['$state', '$rootScope', '$translate', '$window', '$location', 'ContextProcessorService', 'ApplicationService2', 'TenantService', 'AccountService2', 'LoadingService', 'SegmentService', 'BLIP_DOMAIN'];
